export const reportPotReasonModel = [
    {
        value: '0',
        label: 'TERMS',
    },
    {
        value: '1',
        label: 'OFFENSIVE',
    },
    {
        value: '2',
        label: 'WRONG',
    },
    {
        value: '3',
        label: 'OTHER',
    },
];
